import * as React from 'react';

import * as Schema from 'nutshell-core/schema';
import type {EntityListType, FilterObject} from 'nutshell-core/types';

import {FilterDisplayText} from 'shells/filter-capsule/filter-display-text';

type Props = {
    entityType: EntityListType;
    field: Schema.FieldProperties;
    filter: FilterObject | null | undefined;
};

export class FormMap extends React.PureComponent<Props> {
    render() {
        if (!this.props.filter) return null;

        return (
            <FilterDisplayText
                // This just dictates the _color_ of the text.
                // Active text is white, which we don't want here.
                isActive={false}
                field={this.props.field}
                filter={this.props.filter}
                entityType={this.props.entityType}
            />
        );
    }
}
